module.exports = __webpack_public_path__ + "static/media/pic9.bcb3c675.jpg";